import React, { useState, useEffect } from "react";
import { Alert } from "reactstrap";
import "./index.scss";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

const Alerts = () => {

  const dispatch = useDispatch()
  const closeAlert = () =>{
    dispatch({ type: "SHOW_WELCOME_MESSAGE", payload: false });
  }
  return (
    <Alert color="primary">
      Welcome To MORi By TRAiNED &nbsp;
      <Link to="/account-setting" color="link">
        <b>Click Here</b>
      </Link>
      &nbsp;To Setup Your Profile.{" "}
      <span className="btn-close" onClick={closeAlert}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    </Alert>
  );
};
export default Alerts;
